import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './style.css';
import { ContentProvider, useContent } from './contexts/ContentContext';
import useHashScroll from './hooks/useHashScroll';

import Navigation from './components/Navigation';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import Formations from './components/Formations';
import FormationSpecialty from './components/FormationSpecialty';
import FormationDetail from './components/FormationDetail';
import Experts from './components/Experts';
import Contact from './components/Contact';
import Testimonials from './components/Testimonials';
import Galerie from './components/Galerie';
import Admin from './components/admin/Admin';

// Layout component to wrap pages with Navigation and Footer
const Layout = ({ children }) => {
  // Add hash scrolling functionality to all pages
  useHashScroll();

  return (
    <div>
      <Navigation />
      <main>
        {children}
      </main>
      <Footer />
    </div>
  );
};

const AppRoutes = () => {
  const { isLoading, content } = useContent();

  if (isLoading || !content) {
    return (
      <div style={{ minHeight: '40vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p>Chargement du contenu…</p>
      </div>
    );
  }

  return (
    <Router>
      <ScrollToTop />
      <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/services" element={<Layout><Services /></Layout>} />
          <Route path="/formations" element={<Layout><Formations /></Layout>} />
          <Route path="/formations/:specialtySlug/:courseSlug" element={<Layout><FormationDetail /></Layout>} />
          <Route path="/formations/:specialtySlug" element={<Layout><FormationSpecialty /></Layout>} />
          <Route path="/experts" element={<Layout><Experts /></Layout>} />
          <Route path="/temoignages" element={<Layout><Testimonials /></Layout>} />
          <Route path="/galerie" element={<Layout><Galerie /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/admin" element={<Admin />} />
      </Routes>
    </Router>
  );
};

function App() {
  return (
    <ContentProvider>
      <AppRoutes />
    </ContentProvider>
  );
}

export default App;
